export const FILE_LOADING_GET_FILES                     = "FILE_LOADING_GET_FILES";
export const FILE_LOADING_GET_FILES_LOADING             = "FILE_LOADING_GET_FILES_LOADING";
export const FILE_LOADING_SET_FILES                     = "FILE_LOADING_SET_FILES";
export const FILE_LOADING_SET_FILES_LOADING             = "FILE_LOADING_SET_FILES_LOADING";
export const FILE_LOADING_DELETE_FILES                  = "FILE_LOADING_DELETE_FILES";
export const FILE_LOADING_DELETE_LOADING                = "FILE_LOADING_DELETE_LOADING";
